import React from 'react';
import { Typography } from '@mui/material';
import Avatar from '../Avatar';
import { Flex } from '../Flex';
import ChipList, { Props as ChipListProps } from './ChipList';

const OwnerChipListItem = ({ value }: { value: string }) => (
  <Flex sx={{ gap: 1, alignItems: 'center' }}>
    <Avatar size="small" value={{ name: value }} />
    <Typography sx={{ fontSize: '12px', color: 'common.gray2' }}>
      {value}
    </Typography>
  </Flex>
);

const OwnersChipList = React.forwardRef((props: ChipListProps, ref) => (
  <ChipList
    ref={ref}
    {...props}
    renderer={(val) => <OwnerChipListItem value={val} />}
    optionRenderer={(val) => <OwnerChipListItem value={val} />}
  />
));

export default OwnersChipList;
